import { render, staticRenderFns } from "./SendClaimButton.vue?vue&type=template&id=aa4966d0&scoped=true&"
import script from "./SendClaimButton.vue?vue&type=script&lang=js&"
export * from "./SendClaimButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4966d0",
  null
  
)

export default component.exports